<script setup>
import { computed } from 'vue'
import PageToolbar from '@/components/common/PageToolbar.vue'
import ToolbarQueryInput from '@/components/common/ToolbarQueryInput.vue'
import TimeRangeDropdown from './TimeRangeDropdown.vue'
import SourceSelector from '@/components/common/SourceSelector.vue'


const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  timeRange: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'search', 'time-range-change'])

const searchDisabled = computed(() =>
  props.loading || props.disabled || !props.modelValue.trim()
)

function handleSubmit() {
  if (!searchDisabled.value) {
    emit('search')
  }
}
</script>

<template>
  <PageToolbar>
    <SourceSelector :disabled="loading || disabled" always-enabled />

    <ToolbarQueryInput
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
      placeholder="Search events…"
      :disabled="loading || disabled"
      :loading="loading"
      @submit="handleSubmit"
    />

    <TimeRangeDropdown
      :modelValue="timeRange"
      @update:modelValue="$emit('time-range-change', $event)"
      :disabled="loading || disabled"
      always-enabled
    />
  </PageToolbar>
</template>
